import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';

type logCommunityHeatmapsCTAViewedParams = {
  map_location: MapLocation;
};

/**
 * User viewed the community heatmaps CTA
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the user saw the CTAs
 */
const logCommunityHeatmapsCTAViewed = ({ map_location }: logCommunityHeatmapsCTAViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('community heatmaps cta viewed', { 'map location': map_location }, callback);
};

export default logCommunityHeatmapsCTAViewed;
